import wrenLogo from "../../shared/assets/wren.png";

export function SurveyThankYou() {
  return (
    // Inverted brand-callout treatment per the Wren bible: brand-green panel,
    // sage body, white display heading. Full-bleed (no max-width on the outer
    // wrapper) so the green fills the viewport edge-to-edge; an inner column
    // constrains content width. The Wren mark anchors the moment at the top.
    <div
      className="flex min-h-screen min-h-dvh flex-col items-center justify-center px-6 py-12 text-center"
      style={{
        // Radial gradient matching the OG meta image — lighter sage at the
        // upper area, falling off to deep wren-green-deep at the corners.
        // Mirrors the brand-callout pattern from chatwren.com.
        background:
          "radial-gradient(ellipse 100% 80% at 50% 25%, #4a5d4a 0%, #324133 60%, #2c392d 100%)",
      }}
    >
      <div className="flex max-w-md flex-col items-center gap-8">
        <img
          src={wrenLogo}
          alt="Wren"
          className="h-20 w-20 rounded-full"
          // The PNG ships with its own dark-green field that's slightly
          // darker than --color-wren-green; rounding it isolates the mark
          // as a stamp rather than letting the field-color mismatch read
          // as a layout seam.
        />
        <h1
          className="text-[4rem] leading-[1.3]"
          style={{ color: "#ffffff" }}
        >
          Thank you.
        </h1>
        <p
          className="text-[1.25rem] leading-[1.5]"
          style={{ color: "var(--color-wren-light-primary)" }}
        >
          This really does shape what we build next.
        </p>
      </div>
    </div>
  );
}
